export default __webpack_public_path__ + "static/media/money-saving.a0e5ce57.svg";